import type {
  getInsurersQuery,
  InputMaybe,
  InsurersOrderBy,
} from "../../remote/gql/graphql";
import type { ClientReturnType } from "../types";
import type { AlaffiaClientModuleArgs } from "./modules";

import { getInsurersQueryDoc } from "../../remote/queries/getInsurers.gql";
import { AlaffiaClientModule } from "./modules";

type InsurersModuleArgs = AlaffiaClientModuleArgs;

export class InsurersModule extends AlaffiaClientModule {
  constructor(args: InsurersModuleArgs) {
    super(args);
  }

  getInsurers = async (input: {
    orderBy?: InputMaybe<InsurersOrderBy | InsurersOrderBy[]>;
  }): ClientReturnType<getInsurersQuery["insurers"]> => {
    const result = await this.runGqlQuery(
      getInsurersQueryDoc,
      { orderBy: input.orderBy },
      "getInsurers",
    );

    return {
      data: result.data?.insurers ?? null,
      error: result.error ?? null,
    };
  };
}
